import * as React from "react";

import { UitkLayoutGrid, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";

import HotelCard from "../../../ImageLeftSmall/Layouts/GridLayout/HotelCard";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";

interface GridLayoutProps {
  context: ExtendedContextStore;
  model: HotelsFlexModuleResult;
  columns: number & UitkLayoutConditionalGridColumnRow;
}

const GridLayout = (props: GridLayoutProps) => {
  const { context, model, columns } = props;
  const { hotels } = model;

  const keyHelper = new ItemKeyHelper("hotels");

  return (
    <UitkLayoutGrid columns={columns} space="three" className="all-t-margin-three">
      {hotels.map((hotel) => (
        <HotelCard key={keyHelper.next()} context={context} model={model} hotel={hotel} />
      ))}
    </UitkLayoutGrid>
  );
};

export default GridLayout;
